import React from 'react';
import Header from '../components/Header/Header';
import BreadcrumbSchema from "./BreadcrumbSchema";
import ImageViewer from '../components/ImageViewer/ImageViewer';

function Gallery() {
  return (
    <div>
      <BreadcrumbSchema />
      <Header />

      {/* Add top margin above ImageSetter */}
      <div
  className="mt-16"
  style={{
    background: "linear-gradient(135deg, #020617 0%, #0f172a 100%)",
  }}
>
  <ImageViewer />
</div>

    </div>
  );
}

export default Gallery;
